import React, { useRef } from 'react'
import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Select,
  TextArea,
  Checkbox,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import useHolocaustDialog from './useHolocaustDialog'

export default () => {}

export function HolocaustDialog({ message, personId, personName, onSubmitCallback, onCancelCallback }) {
  const { t } = useTranslation()
  const { holocaustDialogState, holocaustDialogActions } = useHolocaustDialog(
    message,
    personId,
    personName,
    onSubmitCallback,
    onCancelCallback,
    true
  )
  const focusElementRef = useRef()

  if (!holocaustDialogState) {
    return null
  }
  return (
    <div>
      <Button onClick={holocaustDialogActions.overlay.handleClick}>{t('queues.holocaust', 'Holocaust')}</Button>
      <DialogOverlay
        {...holocaustDialogActions.overlay}
        focusRef={focusElementRef}
        title={`${personName} (${personId}) - ${t('queues.holocaust', 'Holocaust')}`}
      >
        <Select
          label={t('attribution.chooseLabel', 'Choose a Label')}
          options={[
            {
              value: 'Sensitive issues - Holocaust',
              label: t('queues.sensitiveIssuesHolocaust', 'Sensitive issues - Holocaust'),
            },
            {
              value: 'Sensitive issues - Preemptive Holocaust',
              label: t('queues.sensitiveIssuesPreemptiveHolocaust', 'Sensitive issues - Preemptive Holocaust'),
            },
          ]}
          value={holocaustDialogState.labelSelected}
          onChange={(event) => holocaustDialogActions.setLabelSelected(event.target.value)}
        />
        <TextArea
          ref={focusElementRef}
          label={t('reason', 'Reason')}
          value={holocaustDialogState.changeMessage}
          onChange={(event) => holocaustDialogActions.setChangeMessage(event.target.value)}
        />
        <Checkbox
          label={t('queues.alsoDeleteMessage', 'Also Delete Message')}
          name="selectDeleteMessage"
          checked={holocaustDialogState.deleteMessage}
          onChange={() => {
            return holocaustDialogActions.setDeleteMessageSelected(!holocaustDialogState.deleteMessage)
          }}
        />

        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button
              disabled={!holocaustDialogState.labelSelected}
              onClick={() => holocaustDialogActions.onOk()}
              emphasis="high"
            >
              {t('action.ok', 'OK')}
            </Button>
            <Button onClick={() => holocaustDialogActions.onCancel()} emphasis="medium">
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </div>
  )
}
